import React, { useEffect } from "react";
import { Button } from "theme-ui";
import { useLiquity } from "../../../hooks/LiquityContext";
import { Transaction, useMyTransactionState } from "../../Transaction";
import { useFarmView } from "../context/FarmViewContext";
import { LiquityStoreState } from "@liquity/lib-base";
import { useLiquitySelector } from "@liquity/lib-react";

const transactionId = "farm2-unstake-and-claim";
const selector = ({ liquidityMiningStake2, liquidityMiningLQTYReward2 }: LiquityStoreState) => ({
  liquidityMiningStake2,
  liquidityMiningLQTYReward2
});

export const UnstakeAndClaim: React.FC = () => {
  const { dispatchEvent } = useFarmView();
  const { liquidityMiningStake2, liquidityMiningLQTYReward2 } = useLiquitySelector(selector);
  const hasReward = !liquidityMiningLQTYReward2.isZero;

  const {
    liquity: { send: liquity }
  } = useLiquity();

  const transactionState = useMyTransactionState(transactionId);

  const transactionAction = hasReward
  ? liquity.exitLiquidityMining.bind(liquity, "unipool2")
  : liquity.unstakeUniTokens.bind(liquity, "unipool2", liquidityMiningStake2);

  useEffect(() => {
    if (transactionState.type === "confirmedOneShot") {
      dispatchEvent("UNSTAKE_AND_CLAIM_CONFIRMED2");
    }
  }, [transactionState.type, dispatchEvent]);

  return (
    <Transaction
      id={transactionId}
      send={transactionAction}
      showFailure="asTooltip"
      tooltipPlacement="bottom"
    >
      <Button variant="outline" sx={{ mt: 3, width: "100%" }}>
        Unstake and claim reward
      </Button>
    </Transaction>
  );
};